import {
	setContinueState,
	showFooter,
	hideFooter,
	setContinueUrl,
	setBackUrl,
	changeCartState,
} from './slices'

export const updateContinueState = (isActive) => async (dispatch) => {
	dispatch(setContinueState({ isActive }))
}

export const showFooterBlock = () => async (dispatch) => {
	dispatch(showFooter({}))
}

export const hideFooterBlock = () => async (dispatch) => {
	dispatch(hideFooter({}))
}

export const addContinueUrl = (url) => async (dispatch) => {
	dispatch(setContinueUrl(url))
}

export const addBackUrl = (url) => async (dispatch) => {
	dispatch(setBackUrl(url))
}

export const setCartStateToDefault = () => async (dispatch) => {
	dispatch(changeCartState())
}
